<section class="main">
    <h1>
        Edit Opreator
    </h1>
    <form [formGroup]="OpreatorForm">
        <div class="mb-2">
            <label>Name</label>
            <input formControlName="name" type="text" class="form-control">
        </div>
        <div class="mb-2">
            <label>UserName</label>
            <input formControlName="username" type="text" class="form-control">
        </div>
        <div class="mb-2">
            <label>Email</label>
            <input formControlName="email" type="text" class="form-control">
        </div>
        <div class="mb-2">
            <label>Phone Number</label>
            <input formControlName="phone_number" type="text" class="form-control">
        </div>
    </form>

    <div *ngIf="roles_list.length != 0">
        <h1 class="mt-2 mb-2">Roles</h1>
        <div class="perChoise mb-1">
            <span *ngFor="let item of roles_list">
                {{item.name}}
            </span>
        </div>
    </div>

    <!--  -->

    <div *ngIf="savedRoles_array.lenght != 0">
            <div class="permison mt-2" *ngFor="let item of savedRoles_array">
                <div class="d-flex justify-content-between align-items-center">
                    <h4>Village / Projects</h4>
                    <img style="margin-top: -13px" src="assets/images/edit.png">
                </div>
                <p class="supTilte">{{item.village}}</p>
    
                <div class="roles">
                    <p>Roles</p>
                    <div>
                        <span class="hint" *ngFor="let role of item.roles">
                            {{role.name}}
                        </span>
    
                    </div>
                </div>
    
            </div>
        </div>
    
        <div class="permison mt-2" *ngIf="cardPermison">
            <div class="d-flex align-items-center justify-content-around">
                <div>
                    <input class="me-1" [checked]="status_radio" (change)="changeRadio($event)" type="radio" id="1"
                        name="age" value="1">
                    <label for="1">Villages</label>
                </div>
                <div>
                    <input (change)="changeRadio($event)" class="me-1" type="radio" id="2" name="age" value="2">
                    <label for="2">Project</label>
                </div>
            </div>
    
            <div *ngIf="status_radio">
                <div class="mt-2" >
                    <div class="">
                        <p class="mb-0">Village Name</p>
                        <mat-form-field>
                            <mat-label>Villages</mat-label>
                            <mat-select multiple name="name" [(ngModel)]="villages_list">
                                <mat-option *ngFor="let item of villages_arr" [value]="item">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mt-2">
    
                    <div class="">
                        <p class="mb-0">Add Roles</p>
                        <mat-form-field>
                            <mat-label>roles</mat-label>
                            <mat-select multiple name="name" [(ngModel)]="rols_list">
                                <mat-option *ngFor="let item of roles_arr" [value]="item">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div *ngIf="! status_radio">
                    <div class="mt-2" >
                        <div class="">
                            <p class="mb-0">Project Name</p>
                            <mat-form-field>
                                <mat-label>Projects</mat-label>
                                <mat-select multiple name="name" [(ngModel)]="list_projects">
                                    <mat-option *ngFor="let item of project_list" [value]="item">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="mt-2">
        
                        <div class="">
                            <p class="mb-0">Add Roles</p>
                            <mat-form-field>
                                <mat-label>roles</mat-label>
                                <mat-select multiple name="name" [(ngModel)]="rols_list">
                                    <mat-option *ngFor="let item of roles_arr" [value]="item">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
    
            <div class="mt-4 cardFoter">
                <span style="cursor: pointer" (click)="saveCard()">Save</span>
                <span style="cursor: pointer" (click)="cardPermison = !cardPermison">cancel</span>
            </div>
        </div>

    <button class="btn addPermison" (click)="addPermiosn()">Add new permissions</button>

    <div class="f-b mt-4">
        <button class="btn cancel" mat-dialog-close>Cancel</button>
        <button class="btn add" (click)="addOpreators()">Edit operator</button>
    </div>
</section>
